import { useState, useEffect, useRef } from 'react';
import styles from "../styles/animaGlobalen2.module.css";
import { Link } from "react-router-dom";

export default function AnimaGlobalen2() {
    const contenedorRef = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setVisible(entry.isIntersecting),
            { threshold: 0.5 }
        );

        if (contenedorRef.current) observer.observe(contenedorRef.current);

        return () => {
            if (contenedorRef.current) observer.unobserve(contenedorRef.current);
        };
    }, []);

    return (
        <div ref={contenedorRef} className={`${styles.wrapper} ${visible ? styles.visible : ""}`}>

            {/* Imagen dividida en 2 mitades */}
            <div className={`${styles.imagenDividida} ${visible ? styles.romper : ""}`}>
                <div className={styles.mitadIzquierda}></div>
                <div className={styles.mitadDerecha}></div>
            </div>
            <div className={styles.contletrasGLobal}>
                <img src="assets/letrasGLOBLAL.png" alt="Letras GLOBAL" className={styles.imagenletrasGlobal} />
            </div>
            {/* Imágenes que aparecen desde el centro */}
            {visible && (
                <div className={styles.imagenesFinales}>
                    <Link to="/esport" ><img className={styles.img1} src="assets/img-Parte-Esport.png" alt="parte Esport" />
                    </Link>
                    <Link to="/salut" ><img className={styles.img2} src="assets/img-Parte-Salut.png" alt="parte Salut" />
                    </Link>
                
                </div>
            )}
        </div>
    );
}
